<template>
    <div @click="$store.commit('chopWood')" class="forest"></div>
</template>

<script>
    export default {
        name: "Forest"
    }
</script>

<style lang="scss" scoped>
    .forest {
        cursor: pointer;
        background: url('../../assets/images/forest_full.png') no-repeat;
        background-size: contain;
    }
</style>